export const teamDirectory = {
  contacts: [
    { name: 'Head of Product', role: 'VP Product', email: 'head-of-product@company.com', slack: '@head-product' },
    { name: 'Product Strategy Lead', role: 'Senior Product Manager', email: 'product-strategy@company.com', slack: '@product-strategy' },
    { name: 'Engineering Manager', role: 'Engineering Lead', email: 'eng-manager@company.com', slack: '@eng-manager' },
    { name: 'Design Lead', role: 'Design Manager', email: 'design-lead@company.com', slack: '@design-lead' }
  ],
  mentors: [
    { name: 'Senior Product Mentor', expertise: 'Product Strategy & Roadmap Planning', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Growth Product Mentor', expertise: 'Growth Strategy & Analytics', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Technical Product Mentor', expertise: 'Technical Product Management', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Engineering Teams', contact: 'eng-leads@company.com', purpose: 'Feature Development & Technical Planning' },
    { team: 'Design Team', contact: 'design-team@company.com', purpose: 'User Experience & Design Strategy' },
    { team: 'Marketing Team', contact: 'marketing@company.com', purpose: 'Go-to-Market & Product Positioning' },
    { team: 'Sales Team', contact: 'sales@company.com', purpose: 'Customer Feedback & Market Insights' }
  ],
  channels: {
    primary: '#product-team',
    announcements: '#product-announcements',
    help: '#product-help',
    strategy: '#product-strategy',
    roadmap: '#product-roadmap',
    analytics: '#product-analytics',
    feedback: '#customer-feedback'
  }
};
